<template>
  <div
    class="min-h-[250px] my-7 border-2 border-beige-400 bg-beige-200 grid place-items-center"
  >
    <div class="grid place-items-center">
      <div
        v-if="!hideSpinner"
        class="w-10 mb-7 h-10 border-[3px] border-transparent border-t-red-400 border-l-red-400 rounded-full animate-spin"
      ></div>
      <p class="mb-0">{{ loadingText }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading-spinner',
  props: {
    loadingText: {
      type: String,
      required: true
    },
    hideSpinner: {
      type: Boolean,
      default: false
    }
  }
}
</script>
